// @ts-ignore
import React, { useContext } from 'react';
import RoundedButton from 'components/RoundedButton';
import { PageState } from './PageContent';
import { ValueOf } from 'next/dist/shared/lib/constants';
import { useEnterStore } from 'hooks/stores/useEnterStore';

interface IContinueButtons {
  onContinue: () => void;
}
const ContinueButtons = ({ onContinue }: IContinueButtons) => {
  const { isValid, entryMethod, chooseNumbers } = useEnterStore();

  return (
    <RoundedButton
      className="fullWidth"
      onClick={() => {
        chooseNumbers(onContinue);
      }}
      disabled={!isValid}
    >
      {entryMethod === 'FreeSubscription' ? 'Play Free' : 'Checkout'}
    </RoundedButton>
  );
};

export default ContinueButtons;
